import {
  AmplifyGet,
  AmplifyPost,
} from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import {
  ReworkTaskDetailsResponse,
  ReworkTaskRequest,
  ReworkTaskResponse,
  UpdateActiveProposalResponse,
  WfmTask,
} from "../../../amplify/backend/function/Cap/ts/public/types";
import { SplatProposal } from "../../../amplify/backend/function/OfferExpContacts/ts/public/types";
import { DocumentEmail } from "../capTypes";
import { logger } from "providers/logger";

const postProspectProposalEmail = async (
  jwt: string,
  prospectId: string,
  optionalNotes: string
): Promise<any> => {
  let url = `/prospect/${prospectId}/sendProposalEmail`;
  let body = {
    notes: optionalNotes,
  };
  return AmplifyPost(
    "Send Proposal Email",
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      body,
    },
    logger
  );
};

const postDocumentEmail = async (
  jwt: string,
  document: DocumentEmail,
  prospectId: string,
  proposalToken: string
): Promise<any> => {
  let token = jwt;
  let url = `/prospect/${prospectId}/docEmail`;
  if (!jwt && proposalToken) {
    token = proposalToken;
    url = `/customer/${proposalToken}/docEmail`;
  }
  return AmplifyPost(
    "Send Proposal Email",
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: document,
    },
    logger
  );
};

const getReworkTaskByName = async (
  jwt: string,
  prospectId: string,
  taskName: string
): Promise<WfmTask[]> => {
  const url = `/prospect/${prospectId}/getReworkTaskByName/${taskName}`;

  return AmplifyGet(
    "Get Rework Task By Task Name",
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    logger
  );
};

const getProposals = async (
  jwt: string,
  prospectId: string,
  isCustomer?: boolean
): Promise<SplatProposal[]> => {
  const url = isCustomer
    ? `/customer/${jwt}/proposals`
    : `/prospect/${prospectId}/proposals`;

  return AmplifyGet(
    `${isCustomer ? "Customer " : ""}Get Proposals`,
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    logger
  );
};

const getReworkTaskDetails = async (
  jwt: string,
  taskId: string
): Promise<{ ReworkTaskDetails: ReworkTaskDetailsResponse }> => {
  const url = `/reworkTaskDetails/${taskId}`;

  return AmplifyGet(
    "Get Rework Task Details",
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    logger
  );
};

const postReworkTask = async (
  jwt: string,
  taskId: string,
  body: ReworkTaskRequest
): Promise<ReworkTaskResponse> => {
  const url = `/tasks/${taskId}/reworkTask`;

  return AmplifyPost(
    "Rework Task",
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      body,
    },
    logger
  );
};

const postUpdateActiveProposal = async (
  jwt: string,
  proposalId: string
): Promise<UpdateActiveProposalResponse> => {
  const url = `/updateActiveProposal/${proposalId}`;

  return AmplifyPost(
    "Update Active Proposal",
    "OfferExpApi",
    url,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
      body: {},
    },
    logger
  );
};

export {
  getProposals,
  getReworkTaskByName,
  getReworkTaskDetails,
  postProspectProposalEmail,
  postUpdateActiveProposal,
  postReworkTask,
  postDocumentEmail,
};
